import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box } from '@mui/material';

import { ImageScore } from '../types';

import CurationImageCard from './CurationImageCard';

interface Props {
  image: ImageScore;
  isHero: boolean;
  onClick: (image: ImageScore) => void;
}

export default function SortableCurationImageCard({ image, isHero, onClick }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: image.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Box ref={setNodeRef} style={style} sx={{ position: 'relative' }}>
      <Box
        {...attributes}
        {...listeners}
        sx={{
          position: 'absolute',
          top: 4,
          left: 4,
          zIndex: 2,
          cursor: isDragging ? 'grabbing' : 'grab',
          bgcolor: 'rgba(0,0,0,0.5)',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          p: 0.25,
        }}
      >
        <DragIndicatorIcon sx={{ color: 'common.white', fontSize: 18 }} />
      </Box>
      <CurationImageCard image={image} isHero={isHero} fluid onClick={onClick} />
    </Box>
  );
}
